const Header2 = ({ isDirect }: { isDirect: boolean }) => {
    return (
        <div className="ki-main-header ttukttak type2_header">
            <div className="new-header">
                {/* 히든 클래스 추가 off 25.08.27 */}
                <div className={`new-header-wrap gnb type2_gnb ${isDirect ? 'off' : ''}`}>
                    <div className="gnb_menu flex_b">
                        <div className="logo">
                            <a href="" target="_blank" style={{ pointerEvents: 'none' }}></a>
                            <span className="blind">AI 스마트 평가</span>
                        </div>
                        <div className="gnbBox">
                            <div className="btn-group">
                                {/* <button className="btn btn-icon exit "><i></i><span className="blind">나가기</span></button>  */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Header2;
